import * as Yup from 'yup';

const firstName = Yup.string()
  .trim()
  .min(2, 'First name needs to have 2 characters or more')
  .required('First name is required');

export default firstName;
